import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import paginationFactory from "react-bootstrap-table2-paginator";
import moment from "moment";
import {
  Button,
  UncontrolledPopover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col
} from "reactstrap";
import ExpandedRule from "../Admin/AdminCareProviderDashboard/Expectations/ExpandedRule";
import _ from "lodash";
import LottieLoader from "../LottieLoader";
import lottieEmptyFile from "../../files/animation/empty_new.json";

function priceFormatter(column, colIndex, { sortElement, filterElement }) {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <span className="mb-2">{filterElement}</span>

      {column.text}
      {sortElement}
    </div>
  );
}

function checkSubType(cell, row, index, questionnaireRule) {
  if (row.ruleType === "Trending Violation") {
    const rule = _.find(questionnaireRule, { _id: row.rule[0].ruleId });
    if (rule) {
      return <div>Expectation Name: {rule.name}</div>;
    }
    return "";
  }

  return row.ruleType == "Weight" ? "Weight" : capitalize(cell);
}
function capitalize(cell) {
  if (cell) {
    return cell.charAt(0).toUpperCase() + cell.slice(1);
  }
}
function ruleCheck(cell, row, index) {
  const { sharedUsers = [], conditionGroup = [] } = row;
  if (_.size(sharedUsers) === 0 && _.size(conditionGroup) === 0) {
    return (
      <div>
        <UncontrolledPopover
          trigger="legacy"
          placement="bottom"
          target={"test" + row._id}
        >
          <PopoverHeader>Need Setup</PopoverHeader>
          <PopoverBody>
            This questionnaire is a default one that needs to add a patient to
            monitor or a condition group which has multiple patients, you can
            modify it and delete if you want.
          </PopoverBody>
        </UncontrolledPopover>
        {cell} {"  "}
        <Button
          id={"test" + row._id}
          type="button"
          className="text-danger btn btn-dark btn-rounded float-right py-2"
        >
          <i class="mdi mdi-alert-decagram btn-icon-prepend text-danger"></i>
        </Button>
      </div>
    );
  }
  return cell;
}
const expandRow = {
  renderer: row => (
    <div style={{margin:17}}>
      <ExpandedRule ruleDetails={row} key={row._id + "water"} />
    </div>
  ),
  showExpandColumn: true
};
const MyQuestionnaireList = (props, context) => {
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      {" "}
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    sizePerPageList: [
      {
        text: "10",
        value: 10
      },
      {
        text: "20",
        value: 20
      },
      {
        text: "All",
        value: props.questionnaireRule.length
      }
    ] // A numeric array is also available. the purpose of above example is custom the text
  };
  function formatDate(cell) {
    return moment(cell).format("MMM DD, YYYY hh:mm:ss A");
  }
  return (
    <>
      <div className="care-plan-header-background" style={{ marginTop: 25 }}>
        <Row>
          <Col sm="12" className="center-label remove-table-padding">
            <h3 className="text-center title-device" style={{ marginLeft: 25 }}>
              <i class="mdi mdi-marker-check"></i> QUESTIONNAIRE
            </h3>
          </Col>
        </Row>
      </div>
      <style>
      {`
        /* Apply custom width to expand column */
        .table .expand-cell, 
        .table .expand-header-cell {
          width: 50px; /* Set your desired width here */
        }
      `}
    </style>
     <div className="scrollbar-table-cls">
      <BootstrapTable
        wrapperClasses="table-responsive"
        keyField="_id"
          noDataIndication={() => {
            return (
                <div>
                  <LottieLoader
                      loadLoop={true}
                      autoplayLoop={true}
                      source={lottieEmptyFile}
                      Lheight={300}
                      Lwidth={300}
                      title={"Sorry! No data found"}
                      subTitle={
                          "We can't find any questionnaire."
                      }
                  />
                </div>
            );
        }}
        data={props.questionnaireRule}
        filter={filterFactory()}
        expandRow={expandRow}
        pagination={paginationFactory(options)}
        bordered={true}
        hover={true}
        condensed={true}
        columns={[
          {
            dataField: "name",
            text: "Questionnaire Title",
            sort: true,
            filter: textFilter({
              className: 'input-date-filter'
            }),
            formatter: ruleCheck,
            headerFormatter: priceFormatter
          },{
            dataField: "conditionGroup",
            text: "Condition Group",
            sort: true,
            formatter: (cell, row) => {
              return ruleCheck,_.map(row.conditionGroup, 'condition').join(', ');
            },
            csvFormatter: (cell, row) => {
              return _.map(row.conditionGroup, 'condition').join(', ');
            },
            headerFormatter: priceFormatter
          },
          {
            dataField: "repeatPer",
            text: "Frequency",
            sort: true,
            filter: textFilter({
              className: 'input-date-filter'
            }),
            formatter: checkSubType,
            headerFormatter: priceFormatter,
            formatExtraData: props.questionnaireRule,
            headerStyle: (colum, colIndex) => {
              return { width: "220px" };
            },
          },
          {
            dataField: "createdAt",
            text: "CreatedAt",
            sort: true,            
            formatter: formatDate,
            headerFormatter: priceFormatter,
            formatExtraData: props.questionnaireRule,
            headerStyle: (colum, colIndex) => {
              return { width: "235px" };
            },
          }
        ]}
      />
    </div>
    </>
  );
};

export default MyQuestionnaireList;
